export default __webpack_public_path__ + "static/media/rithmic.a9a65202.webp";